//Wishlist Area
  function wishlist_init(){    
    if(localStorage.getItem('wishlist-id') == '[]' || localStorage.getItem('wishlist-id') == null ){
      $('.wlnumber').html('0');
    }
    else{
      var activeID = [];
      activeID = JSON.parse(localStorage.getItem('wishlist-id'));
      $('.wlnumber').html(activeID.length);     
      for(i=0; i<activeID.length; i++ ){
        var classadded = '.wl-'+activeID[i];        
        $(classadded).addClass("wlc-added").removeClass("wlc").attr("title","Added to My Wishlist");
      }
    }
  }

  function wishlist_add(){
    $( "a.wlc" ).on( "click", function(e) {
      if(!$(this).hasClass('wlc-added')){
        e.preventDefault();                  

        //store product ID      
        var storeID = [];
        if(localStorage.getItem('wishlist-id') == null )
          storeID = [];
        else
          storeID = JSON.parse(localStorage.getItem('wishlist-id'));
        storeID.push($(this).data("wishlistid"));
        localStorage.setItem('wishlist-id', JSON.stringify(storeID));  

        //add class and animation                
        $(this).addClass("wlc-added").removeClass("wlc").attr("title","Added to My Wishlist");
        $(this).find('i').removeClass('fa-heart').addClass('fa-check');
        setTimeout(function () {          
          $('.wlc-added').find('i').addClass('fa-heart').removeClass('fa-check');
        },700);
      }     
    });
  }  
  
  function wishlist_show(){    
    var cont = '#wishlistcontent ul',
        productjson = '/products.json',
        getID= [];
    if(localStorage.getItem('wishlist-id') != '[]' && localStorage.getItem('wishlist-id') != null ){
      $('.wltable').removeClass('hide');
      getID = JSON.parse(localStorage.getItem('wishlist-id'));
      for(j=0; j<getID.length; j++){
        var url = "/products/"+getID[j]+".js";
        jQuery.getJSON(url, function(product) {
          console.log(234);
          var wcn = ".wishlist-"+product.handle;    
          $(cont).append('<li class="wlr wishlist-'+product.handle+' grid__item one-whole"><div class="wishlist-image grid__item two-tenths"></div><div class="wishlist-name grid__item three-tenths"></div><div class="wishlist-price grid__item two-tenths"></div><div class="wishlist-remove grid__item one-tenth" data-wishlistid="'+product.handle+'"><i class="fa fa-times" aria-hidden="true"></i></div><div class="wishlist-detail grid__item two-tenths"></div></li>');                    
          $(wcn).find('.wishlist-image').append('<img src="'+product.featured_image+'" alt="" />');          
          $(wcn).find('.wishlist-name').append('<a href="'+product.url+'">'+product.title+'</a>'); 
          var price_compare = "";
          if ( product.compare_at_price != null ){
            price_compare='<del class="price_compare"><span class="money">'+ Shopify.formatMoney(product.compare_at_price, cart_money_format) +'</span></del>';
          }
          $(wcn).find('.wishlist-price').append('<span class="price money">'+Shopify.formatMoney(product.price, cart_money_format) + '</span>'+ price_compare);              
          $(wcn).find('.wishlist-remove').on("click", function(){ 
            $(wcn).hide("fade");
            var storeID2= [],
                ri = $(this).data("wishlistid");            
            storeID2 = JSON.parse(localStorage.getItem('wishlist-id'));            
            storeID2 = jQuery.grep(storeID2, function(value) {
              return value != ri;
            });
            localStorage.setItem('wishlist-id', JSON.stringify(storeID2));            
            $('.wlnumber').html(storeID2.length);
            if(storeID2.length == 0) {
              $('.wishlist-heading').hide();
              $('.wlempty').removeClass('hide');
            }
          });
          $(wcn).find('.wishlist-detail').append('<a href="'+product.url+'">View More</a>');
        });
      }
    }
    else{      
      $('.wishlist-heading').hide();   
      $('.wlempty').removeClass('hide');
    }
  }

$(document).ready(function($) {
  wishlist_init();
  wishlist_add();
  if(wlpage) wishlist_show();   
});